<template>
<div>
			<!-- NOTIFICATIONS -->
			<vs-select
            autocomplete
            v-model="select1"
            class="w-full select-large mt-4"
            placeholder="Tous"
			@change="filterStatus(select1)"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in statusList"
              class="w-full"
            />
    </vs-select>
	<br>
	<vs-table :data="allNotification"  style="overflow-x: hidden">
		<template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(ntf, indextr) in data" :style="ntf.is_viewed == 0? `background-color: #F3F2F7`:`background-color: #fff`">
          <vs-td :data="data[indextr].email">
            <vs-icon :id= "ntf.index" :icon="ntf.icon" icon-pack="material-icons" size="25px" :color ="ntf.color"  ></vs-icon>
          </vs-td>

          <vs-td :data="data[indextr].username" style = "height: 5rem; overflow: hidden; ">
			<div v-on:click="notificationTapped(ntf.id,ntf.route, ntf.args)" style="cursor: pointer">
			<p :style= "`font-size: 10px; font-weight: 600; color:`+ntf.color+`;`">{{ ntf.description }}</p>
		</div>
          </vs-td>

          <vs-td :data="data[indextr].id">
			<div :class="ntf.need_check == 1 ?`with-check`:`without-check`">
			<vs-button
			v-if = "ntf.need_check ==1"
                size="small"
                :color="ntf.is_viewed ==1 ?'success':'warning'"
                type="flat"
				:disabled = "ntf.is_viewed ==1?true:false"
                icon-pack="material-icons"
                :icon= "ntf.is_viewed ==1 ? 'check' : 'visibility'"
				@click.stop = "checkButtonTapped(ntf.id, ntf.is_viewed)"
                hide-details
              >
			</vs-button>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.creation_date) }}</small>

			</div>
          </vs-td>
        </vs-tr>
      </template>
	</vs-table>
        <!-- <ul class="bordered-items" :key="refreshList">
        <li v-for="(ntf, index) in allNotification" :key="index +'x'+refreshList" class="notification cursor-pointer" >
		<div class = "row w-full">
		<div class="flex items-start px-4 py-4 col-md-6 notification-container"  :style="ntf.is_viewed == 0? `background-color: #F3F2F7;display: flex !important; justify-content: space-between !important; width:100% !important`:`background-color: #fff;display: flex !important; justify-content: space-between !important; width:100% !important` ">
            <div class="flex items-start" v-on:click="notificationTapped(ntf.id,ntf.route, ntf.args)" >
			<vs-icon :icon="ntf.icon" icon-pack="material-icons" size="25px" :color ="ntf.color" ></vs-icon>
                        <div class="ml-5 mx-2" style = "width: 70rem; overflow: hidden;">
                <p :style= "`font-size: 10px; font-weight: 600; color:`+ntf.color+`;`">{{ ntf.description }}</p>
              </div>
            </div>
			<div :class="ntf.need_check == 1 ?`with-check`:`without-check`">
				<vs-button
				v-if = "ntf.need_check ==1"
                size="small"
                :color="ntf.is_viewed ==1 ?'success':'warning'"
                type="flat"
				:disabled = "ntf.is_viewed ==1?true:false"
                icon-pack="material-icons"
                :icon= "ntf.is_viewed ==1 ? 'check' : 'visibility'"
				@click.stop = "checkButtonTapped(ntf.id, ntf.is_viewed)"
                hide-details
              ></vs-button>
            <small class="ml-3 mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.creation_date) }}</small>
			</div>
			</div>
			</div>
          </li>
        </ul> -->
	</div>
</template>

<script>
import Contracts from "@/views/dashboard/Contracts.vue";
import Vue from "vue";
import VueCookies from "vue-cookies";
import moment from "moment";
import store from "@/store/store";
import router from "@/router.js";
export default {
	name: "AllPersonalNotificationPopup",

	props: {
		unreadNotification: Array,
		show: Boolean,
		allListNotification: Array,
	},
	data() {
		return {
			select1: 0,
			allNotification: [],
			statusList: [
				{text: "Tous", value: 0},
				{text: "A Traiter", value: 1},
				{text: "Traitée", value: 2},
			],
			refreshList: 0,
			toogleReload: true,
			doReload: false,
			showPopup: this.$props.show,
			staticNewCountNotification: null,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: .60,
			},
		};
	},
	mounted() {
		this.allNotification = this.allPersoNotification;
		//console.log("UPDATED", this.allNotification);
	},
	created() {
		this.allNotification = this.allPersoNotification;
		//console.log("CREATED", this.allNotification);
	},
	computed: {
		allPersoNotification(){
			return store.state.personalNotification.data;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		unreadNotifications(){
			return this.$props.unreadNotification;
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		}
	},
	watch: {

		toogleReload(){
			router.go();
		},
		unreadNotifications(){
			//to not refresh the inside new notification count
			if(!this.staticNewCountNotification){
				this.staticNewCountNotification = this.$props.newCount;
			}
		}
	},
	methods:
	{
		filterStatus(data){
			if(data && data != 0){
				let temp = [...this.allPersoNotification];
				let content = temp.filter((ele) => ele.is_viewed == data-1);
				this.allNotification = JSON.parse(JSON.stringify(content));
			}
			else{
				this.allNotification = JSON.parse(JSON.stringify(this.allPersoNotification));
			}
		},
		async notificationTapped(id, route, args){
			if(route == "contracts"){
				let ComponentClass = Vue.extend(Contracts);
				let contractPopup = new ComponentClass({
					propsData: {
						contract: this.selectedContract,
						popupActive: this.showContractPopup,
						router: this.$router,
					// apiUrl: this.apiUrl
					}
				});
				this.$refs["popupContract"] = contractPopup;
				this.$refs.popupContract.showContactInfoPopup(JSON.parse(args));
			}
			else if(route == "commercial_notification"){
				this.$emit("rc-show-popup");
			}
		},
		checkButtonTapped(id,){
			this.$http.post("personal_notification/update/check/"+ id)
				.then(() => {
					store.dispatch("getPersonalNotificationList", this.activeUser.id);
					this.allNotification.forEach((ele) => {
						if(ele.id == id){
							ele.is_viewed = 1;
						}
					});
					this.refreshList++;
				})
				.catch(err => console.log(err));


		},
	
		elapsedTime(startTime) {
			let x = new Date(moment(startTime).local().format("YYYY-MM-DD HH:mm:ss"));
			let now = new Date();
			var timeDiff = now - x;
			timeDiff /= 1000;

			var seconds = Math.round(timeDiff);
			timeDiff = Math.floor(timeDiff / 60);

			var minutes = Math.round(timeDiff % 60);
			timeDiff = Math.floor(timeDiff / 60);

			var hours = Math.round(timeDiff % 24);
			timeDiff = Math.floor(timeDiff / 24);

			var days = Math.round(timeDiff % 365);
			timeDiff = Math.floor(timeDiff / 365);

			var years = timeDiff;

			if(years > 0) {
				return years + (years > 1 ? " années" : " année");
			}
			else if(days > 0) {
				return days + (days > 1 ? " jours" : " jour");
			}
			else if(hours > 0) {
				return hours + (hours > 1 ? " heures" : " heure");
			}
			else if(minutes > 0) {
				return minutes + (minutes > 1 ? " minutes" : " minute");
			}
			else if(seconds > 0) {
				return seconds + (seconds > 1 ? " sec" : "maintenant");
			}

			return "Maintenant";
		},
		// Method for creating dummy notification time
		randomDate({hr, min, sec}) {
			let date = new Date();

			if(hr) date.setHours(date.getHours() - hr);
			if(min) date.setMinutes(date.getMinutes() - min);
			if(sec) date.setSeconds(date.getSeconds() - sec);

			return date;
		},
	}
};
</script>
<style>
.notification-container{
	height: 70px;
    align-items: center !important;
    justify-items: center !important;
    display: flex !important;
    justify-content: space-between !important;
    width: 100% !important;
}
.with-check{
	justify-items: center;
	display: inline-grid;
}
.without-check{
	height: 100%;
    /* justify-items: baseline; */
    display: inline-grid;
    align-items: center;
}
</style>